<template>
  <div id="app">
    <transition name="page" mode="out-in">
    <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
.page-enter-active, .page-leave-active {
  transition: opacity 0.5s , transform 0.5s;
}
.page-enter, .page-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/App.vue